import moment from 'moment';

import { TOrbit } from '../../../i18n/TModules';
import { WizardLimits, WizardState } from '../wizardModel';
import { positive } from './common';
import { Translate } from './ruleAdapter';

const TL = `${TOrbit}.wizard.limits`;

type CountLine = [on: keyof WizardLimits, value: keyof WizardLimits];

// The number lines each type's Step 5/5 draws.
const COUNT_LINES: Record<NonNullable<WizardState['type']>, CountLine[]> = {
  stamp: [
    ['totalOn', 'total'],
    ['perUserOn', 'perUser'],
    ['userRateOn', 'userRate']
  ],
  quest: [
    ['totalOn', 'total'],
    ['perUserOn', 'perUser']
  ],
  progress: [],
  game: [
    ['totalOn', 'total'],
    ['perUserOn', 'perUser'],
    ['userRateOn', 'userRate']
  ],
  instant_outcome: [
    ['totalOn', 'total'],
    ['perUserOn', 'perUser'],
    ['rateOn', 'rate'],
    ['userRateOn', 'userRate']
  ]
};

/** What Step 5/5 still needs: every checked line a whole number of 1 or more, and dates in order. */
export const limitErrors = (state: WizardState, t: Translate): string[] => {
  const { limits } = state;
  const errors: string[] = [];
  const counts = COUNT_LINES[state.type ?? 'stamp'];
  const window = (state.type === 'quest' || state.type === 'progress') && !limits.autoEnrol;
  const badCount =
    counts.some(([on, value]) => limits[on] === true && !positive(limits[value] as string)) ||
    (window && limits.windowOn && !positive(limits.windowDays));
  if (badCount) {
    errors.push(t(`${TL}.positive`));
  }
  if (
    limits.endOn &&
    limits.end !== null &&
    !moment(limits.end).isAfter(limits.start === null ? moment() : moment(limits.start))
  ) {
    errors.push(t(`${TL}.endBeforeStart`));
  }
  return errors;
};
